import { transformValueFloattoFormated } from "beaktShared/helpers/masks";

// Helpers de exibição do fechamento de royalties (regra V2).
// Nenhuma regra financeira é calculada aqui: os valores vêm prontos do servidor.

export const REGRA_V2 = "V2";
export const MODO_PARCELADO = "parcelado";
export const MODO_AVISTA = "avista";
export const MODO_AUTOMATICO = "auto";
// Matriz confirmou o pagamento antes do aceite da clínica, sem taxa (gravado pela API; não é escolhido na tela)
export const MODO_INTEGRAL = "integral";

// Média de parcelas do processamento (base da taxa e da parcela V2). mediaParcelas é a do aceite.
export const mediaParcelasV2 = (item) => (item && item.mediaParcelasV2 != null ? item.mediaParcelasV2 : item && item.mediaParcelas);

const toNumber = (value) => (value ? Number(value) : 0);

export const isRegraV2 = (item) => !!item && item.regraVersao === REGRA_V2;

// Moeda em 2 casas: fechamentos antigos gravaram valores com 4 (coluna Money) e o toLocaleString exibia 3
export const formatMoney = (value) => transformValueFloattoFormated(Math.round((toNumber(value) + Number.EPSILON) * 100) / 100);

// "positive" | "negative" | "neutral" — usado para colorir resultados (verde/vermelho)
export const signTone = (value) => {
    const n = toNumber(value);
    if (n > 0) return "positive";
    if (n < 0) return "negative";
    return "neutral";
};

// "4,47% · 587,04"
export const formatTaxa = (pct, valor) => `${formatMoney(pct)}% · ${formatMoney(valor)}`;

// Média de parcelas 0 é tratada como 1 (mesma regra do servidor)
export const parcelasExibicao = (mediaParcelas) => (toNumber(mediaParcelas) > 0 ? toNumber(mediaParcelas) : 1);

// "09/2026" -> "10/2026"
export const proximaCompetencia = (mesAno) => {
    if (!mesAno || mesAno.indexOf("/") === -1) return "";
    const [mes, ano] = mesAno.split("/").map(Number);
    if (!mes || !ano) return "";
    const proxMes = mes === 12 ? 1 : mes + 1;
    const proxAno = mes === 12 ? ano + 1 : ano;
    return `${String(proxMes).padStart(2, "0")}/${proxAno}`;
};

// Antes do aceite o servidor devolve totalReceberAVista do modo parcelado (modoRecebimento nulo) e
// totalReceberAVistaModoAvista com o total caso a clínica escolha "à vista". O front só escolhe qual exibir.
export const totalReceberAVistaExibicao = (item, modo) => {
    if (modo === MODO_AVISTA && !item.dataAceite)
        return toNumber(item.totalReceberAVistaModoAvista);
    return toNumber(item.totalReceberAVista);
};

// "Receber/Pagar" e "Resultado do fechamento" V2 (listagem e extratos): saldo integral pronto da API
// (resultadoFechamento), mesma base do valorReceberPagar do LEGADO. O front só exibe.
export const resultadoFechamentoV2 = (item) => (item ? toNumber(item.resultadoFechamento) : 0);

// Linhas da "Memória de cálculo" (sem a linha "Abatido da dívida", fora de escopo).
// labelKey/valueKey são chaves i18n resolvidas pelo componente.
export const memoriaCalculo = (item, modo) => {
    const automatica = item.antecipacaoAutomatica === true;
    const mostraTaxa = automatica || modo === MODO_AVISTA;
    const temDivida = toNumber(item.dividaAnterior) > 0;

    return [
        { labelKey: "royaltie.v2_cash_credits", value: formatMoney(item.creditosAVista) },
        { labelKey: "royaltie.v2_memory_minus_month_debits", value: formatMoney(item.debitosMes) },
        { labelKey: "royaltie.v2_memory_equals_month_result", value: formatMoney(item.resultadoMes) },
        { labelKey: "royaltie.v2_memory_previous_debt", value: formatMoney(item.dividaAnterior) },
        {
            labelKey: "royaltie.v2_memory_debt_greater_than_result",
            valueKey: automatica
                ? "royaltie.v2_memory_yes_automatic"
                : (temDivida ? "royaltie.v2_memory_no_debt_deducted" : "royaltie.v2_memory_no_debt")
        },
        {
            labelKey: "royaltie.v2_memory_rate",
            value: mostraTaxa ? `${formatMoney(item.taxaAntecipacaoPct)}% = ${formatMoney(item.taxaAntecipacaoValor)}` : "—"
        },
        { labelKey: "royaltie.v2_memory_net_credit", value: automatica ? formatMoney(item.creditoLiquidoAntecipado) : "—" },
        { labelKey: "royaltie.v2_memory_amount_to_deposit", value: formatMoney(item.valorDepositar) },
        {
            labelKey: "royaltie.v2_memory_balance_carried",
            labelParams: { competencia: proximaCompetencia(item.mesAno) },
            value: formatMoney(item.saldoDevedorRemanescente)
        }
    ];
};
